import {
  SSH_USER_NAME_REGEX,
  UNIX_USERNAME_REGEX,
  USER_NAME_REGEX,
  USER_NAME_WITH_UNDERSCORES_REGEX,
  USERNAME_WITH_OPTIONAL_DOT_REGEX,
} from '../regex/constants';

export const onValidUsername = (val: string) => {
  return USER_NAME_WITH_UNDERSCORES_REGEX.test(val);
};

export const onSSHValidUsername = (val: string) => {
  return SSH_USER_NAME_REGEX.test(val);
};

export const isValidUnixUsername = (val: string) => {
  return val.length > 4 ? UNIX_USERNAME_REGEX.test(val) : false;
};

export const isValidUsername = (val: string) => {
  return USER_NAME_REGEX.test(val);
};

export const isValidSshUsername = (val: string) => {
  return val.length > 4 ? SSH_USER_NAME_REGEX.test(val) : false;
};

export const isValidUsernameWithOptionalDot = (val: string) => {
  return USERNAME_WITH_OPTIONAL_DOT_REGEX.test(val);
};
